function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "paapaya_main2",
  transform: "translate(-208.000000, -1165.000000)",
  fill: "#EEEEEE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-28",
  transform: "translate(149.000000, 767.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22-Copy",
  transform: "translate(52.000000, 389.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4422151,0.102254421 C9.34208388,-0.0345200465 4.65704107,-0.0336488716 2.55778486,0.102254421 C0.282642665,0.249482988 0.0201262579,1.55711659 0,5 C0.0166260391,8.43591401 0.282642665,9.74877466 2.55778486,9.89774558 C4.65791612,10.0336489 9.34033377,10.03452 11.4422151,9.89774558 C13.7173573,9.74964584 13.9798737,8.44201223 14,5 C13.983374,1.56408599 13.7173573,0.250354163 11.4422151,0.102254421 Z M5.38461538,7.22222222 L5.38461538,2.77777778 L10.2307692,4.99651416 L5.38461538,7.22222222 Z",
  id: "Shape"
}))))));

function SvgIcoYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoYt);
export default __webpack_public_path__ + "static/media/ico_yt.ae0ea976.svg";
export { ForwardRef as ReactComponent };